import {TypeAccountRoles} from '../types/user-account.types';

export const checkAuthorities = (possibleRoles: TypeAccountRoles[], roles: TypeAccountRoles[]) =>
  possibleRoles.some((possibleRole) => roles.includes(TypeAccountRoles.ADMIN) || roles.includes(possibleRole));
